import './index.scss'
$(".product-nav dl dt").click(function() {
    $(this).parent().toggleClass("active");
    $(this).parent().find(".dd").slideToggle();
})


